import React from 'react'
import IconFont from '../IconFont'

interface FailMessageProps {
  children: React.ReactNode
}

const FailMessage: React.FC<FailMessageProps> = ({ children }) => {
  return (
    <>
      <IconFont style={{ marginRight: 4 }} name="jinggao" size={14} color="f5222d" />
      {children}
    </>
  )
}

export default FailMessage
